import { jsonToConvex } from "../index.js";
/**
 * A represention of the query results we've received on the current WebSocket
 * connection.
 */
export class RemoteQuerySet {
    constructor() {
        this.version = { querySet: 0, ts: BigInt(0), identity: 0 };
        this.remoteQuerySet = new Map();
    }
    transition(transition) {
        const start = transition.startVersion;
        if (this.version.querySet !== start.querySet ||
            this.version.ts !== start.ts ||
            this.version.identity !== start.identity) {
            throw new Error(`Invalid start version: ${start.ts}:${start.querySet}`);
        }
        for (const modification of transition.modifications) {
            switch (modification.type) {
                case "QueryUpdated": {
                    for (const line of modification.logLines) {
                        console.log(`%c[CONVEX Q(${name})] ${line}`, "color:blue");
                    }
                    const value = jsonToConvex(modification.value ?? null);
                    this.remoteQuerySet.set(modification.queryId, value);
                    break;
                }
                case "QueryRemoved": {
                    this.remoteQuerySet.delete(modification.queryId);
                    break;
                }
                default: {
                    throw new Error(`Invalid modification ${modification}`);
                }
            }
        }
        this.version = transition.endVersion;
        return this.remoteQuerySet;
    }
    timestamp() {
        return this.version.ts;
    }
}
//# sourceMappingURL=remote_query_set.js.map